import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import DynamicForm from "./dynamicForm";

export default function IntakePage() {
  const { token } = useParams(); // ← grab :token from /intake/:token
  const [schema, setSchema] = useState(null);
  const [appointmentId, setAppointmentId] = useState(null);
  const [formTemplateId, setFormTemplateId] = useState(null);
  const [state, setState] = useState("loading"); // loading | error | done

  // 1️⃣  Fetch schema by token
  useEffect(() => {
    if (!token) return;
    fetch(`/api/attorney/webapp/intake/client/getForm?token=${token}`)
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((data) => {
        setSchema(data[0].parsed_json);
        setAppointmentId(data[0].appointment_id);
        setFormTemplateId(data[0].form_template_id);
        setState("ready");
      })
      .catch(() => setState("error"));
  }, [token]);

  // 2️⃣  Submit answers
  const submit = async (answers) => {
    const r = await fetch("/api/attorney/webapp/intake/client/submitForm", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, answersJson: answers }),
    });
    setState(r.ok ? "done" : "error");
  };

  /* 3️⃣  Render states */
  if (state === "loading") return <Centered>Loading…</Centered>;
  if (state === "error")
    return <Centered>Link invalid, used, or expired.</Centered>;
  if (state === "done")
    return <Centered>Thank you! Your info was sent.</Centered>;

  return (
    <DynamicForm
      schema={schema}
      onSubmit={submit}
      appointmentId={appointmentId}
      formTemplateId={formTemplateId}
    />
  );
}

/* Simple centered wrapper */
function Centered({ children }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        fontSize: "1.1rem",
        color: "#374151",
      }}
    >
      {children}
    </div>
  );
}
